module.exports = __webpack_public_path__ + "static/media/study 201129.27712556.png";